import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathpoints"
    }}>{`PathPoints`}</h1>
    <p>{`A collection of `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
      }}>{`PathPoint`}</a>{` objects that define a subpath, kept in the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/#pathpoints"
      }}>{`SubPathItem.pathPoints`}</a>{` property.`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[index: `}<em parentName="p">{`number`}</em>{`]`}{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
      }}><em parentName="a">{`PathPoint`}</em></a></p>
    <p>{`Used to access the guides in the collection`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of elements in this collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
            }}><em parentName="a">{`SubPathItem`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The containing subpath object.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      